import React from "react"; 
import SignInForm from "../../components/Auth/SignInForm";

const SignIn = () => {
  return (
    <>
      <SignInForm />
    </>
  );
};

export default SignIn;
